import { type UserDetailsDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/util/useApiClient.util.ts';
import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

type Response = UserDetailsDto | undefined;

interface Return {
  currentUser: Response;
  error: AxiosError | null;
  isLoading: boolean;
}

export const useGetCurrentUser = (): Return => {
  const { restUserApi } = useApiClient();

  const { data, error, isLoading, isPending } = useQuery<Response, AxiosError>({
    meta: { disable400: true },
    queryFn: async () => {
      const response = await restUserApi.getCurrentUser();
      return response.data;
    },
    queryKey: [QueryKeyEnum.GET_CURRENT_USER],
    staleTime: Infinity,
  });

  return { currentUser: data, error, isLoading: isLoading || isPending };
};
